import React from "react";
import { AppLayout } from "@bcc/components/app-layout";
import { ProductsView } from "@bcc/components/views/products-view";
import { useProductsState } from "@client-shared/providers/products";
import { useInstallationsState } from "@client-shared/providers/installations";
import { transformFormProducts } from "@bcc/lib/transform";

// Products page component
export function ProductsPage() {
  const [installationsState, , installationsMethods] = useInstallationsState();
  const [productsState, , productsMethods] = useProductsState();

  // Fetch installations on mount
  React.useEffect(() => {
    if (
      !installationsState.initialized ||
      (installationsState.installations?.size ?? 0) > 0 ||
      installationsState.error ||
      !installationsMethods?.fetch
    ) {
      return;
    }
    installationsMethods.fetch();
  }, [
    installationsState.initialized,
    installationsState.installations,
    installationsState.error,
    installationsMethods,
  ]);

  // Set installation ID when installations are available
  React.useEffect(() => {
    if (
      !installationsState.installations ||
      installationsState.installations.size === 0 ||
      !productsMethods?.handleInstallationId
    ) {
      return;
    }
    // Get first installation ID from the Map
    const installationId = installationsState.installations.keys().next().value;
    if (!installationId) return;
    productsMethods.handleInstallationId(installationId);
  }, [installationsState.installations, productsMethods]);

  // Derive loading state from provider
  const isLoading = React.useMemo(() => {
    return (
      productsState.loading.remoteProducts ||
      productsState.loading.localProducts ||
      productsState.loading.connections
    );
  }, [
    productsState.loading.remoteProducts,
    productsState.loading.localProducts,
    productsState.loading.connections,
  ]);

  // Transform FormProduct[] to Product[] for the table
  const products = React.useMemo(
    () => transformFormProducts(productsState.remoteFormProductsWithImported),
    [productsState.remoteFormProductsWithImported],
  );

  return (
    <AppLayout>
      <ProductsView
        productsData={products}
        isLoading={isLoading}
        error={productsState.error.remoteProducts}
      />
    </AppLayout>
  );
}
